export const vehicle = {
  vehicleID: "Vehicle ID",
  authorizedDrivers: "Authorized Drivers",
  firmware: "Firmware",
  sensors: "Sensors",
  deviceModel: "System Model",
  vehicleModel: "Vehicle Model",
  WiFiSettings: "Wi-Fi Settings",
  WiFiSSID: "Wi-Fi Name",
  WiFiPassword: "Wi-Fi Password",
  WiFiMode: "Wi-Fi Mode",
  alertSettings: "Alert Settings",
  AIFeature: "AI Features",
  SpeedSensor: "Speed Sensor",
  Front: "Front Camera",
  Rear: "Rear Camera",
  Left: "Left Camera",
  Right: "Right Camera",
  DSS: "DSS Camera",
  calibrationStatus: "Calibration Status",
  cameraInstallationHeight: "Camera Installation Height",
  warningBoundaryDistance: "Warning Boundary Distance",
  criticalBoundaryDistance: "Critical Boundary Distance",
  detectionFiledOfView: "Detection Field of View",
  pdAlertsDSSFrontAlert: "Front Alerts",
  pdAlertsDSSRearAlert: "Rear Alerts",
  pdAlertsDSSLeftAlert: "Left Alerts",
  pdAlertsDSSRightAlert: "Right Alerts",
  pdAlertsDSSAlert: "DSS Alerts",
  primaryDetection: "Primary Detection",
  adaptiveDetection: "Adaptive Detection",
  warningZone: "Warning Zone",
  criticalZone: "Critical Zone",
  on: "On",
  off: "Off",
  photo: "Photo",
  fleet: "Fleet",
  notes: "Notes",
  available: "Available",
  unAvailable: "Unavailable",
  Fatigue: "Fatigue",
  Phone: "Phone Usage",
  Smoking: "Smoking",
  SeatBeltSensor: "SeatBelt Sensor",
  ReverseLightSensor: "Reverse Light Sensor",
  SeatBeltSensorBattery: "SeatBelt Sensor Battery",
  Good: "Good",
  LessThanAMonth: "Less than a Month",
  LessThanAWeek: "Less than a Week",
  calibrated: "Calibrated",
  uncalibrated: "Uncalibrated",
  max: "Max",
  SpeedSensorBattery: "Speed Sensor Battery",
  SpeedSensorInstallationPosition: "Speed Sensor Position",
  TireLeft: "Left side of tire",
  TireRight: "Right side of tire",
  storage: "Storage",
  SDCard: "SD Card",
  SDCardNotFound: "Unrecognized",
  lowBattery: "Low Battery",
  low: "Low",
  AiFeatureTips:
    "(The settings will not take effect until the camera is calibrated)",
  unConnected: "Disconnected",
  accessory: "Accessory",
  driveTrainType: "Drive",
  maintenanceRemind: "Maintenance Due",
  vehicleCheckDue: "Vehicle Inspection Due",
  vehicleCheckPhoto: "Vehicle Inspection Photo",
  frontRightCamera: "Front Right Camera",
  rearRightCamera: "Rear Right Camera",
};
